export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-latin-500-normal.woff2?1b99f55e4c0258b75c893c8231c90c23";